module.exports = __webpack_public_path__ + "img/grape.be5030ca.webp";